import { render, staticRenderFns } from "./EventiImmaginiEditComponent.vue?vue&type=template&id=a7fbe2ac"
import script from "./EventiImmaginiEditComponent.vue?vue&type=script&lang=js"
export * from "./EventiImmaginiEditComponent.vue?vue&type=script&lang=js"
import style0 from "./EventiImmaginiEditComponent.vue?vue&type=style&index=0&id=a7fbe2ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports